import { Link } from '@/ui-components/atoms/Link/Link';
import { NavDropdownContentProps } from '../../NavHeader.type';
import styles from '../../NavHeaderComponents/drawer.module.scss';

interface NavDropdownSectionMobileProps {
    navDropdownContentMobile: {
        listItems: {
            linkText: string;
            href: string;
        }[];
        tileContent: NavDropdownContentProps['tileSection'];
    };
}

export function NavDropdownSectionMobile({ navDropdownContentMobile }: NavDropdownSectionMobileProps) {
    return (
        <div className={styles.mobileNavDropdownWrapper}>
            <ul className={styles.navList}>
                {navDropdownContentMobile.listItems.map((item, index) => {
                    return (
                        <li key={index} className={styles.navItem}>
                            {item.href && (
                                <Link href={item.href} className={styles.navLink}>
                                    {item.linkText}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ul>
            <div className={styles.mobileTileContainer}>{navDropdownContentMobile.tileContent}</div>
        </div>
    );
}
